import { render, staticRenderFns } from "./goodAdd.vue?vue&type=template&id=1c2de0f5&scoped=true&"
import script from "./goodAdd.vue?vue&type=script&lang=js&"
export * from "./goodAdd.vue?vue&type=script&lang=js&"
import style0 from "./goodAdd.vue?vue&type=style&index=0&id=1c2de0f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2de0f5",
  null
  
)

export default component.exports